/* eslint-disable */
import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    component: () => import('../views/login/login-index'),
    meta: { title: '车管家' }
  },
  {
    path: '/profile',
    component: () => import('../views/profile/profile-index'),
    meta: { title: '个人资料' }
  },
  {
    path: '/profileInput',
    component: () => import('../views/profile/profile-edit-input'),
    meta: { title: '车管家' }
  },
  {
    path: '/profileUpload',
    component: () => import('../views/profile/profile-edit-upload'),
    meta: { title: '车管家' }
  }, {
    path: '/profilePicker',
    component: () => import('../views/profile/profile-picker'),
    meta: { title: '车管家' }
  },
  {
    path: '/orderIndex',
    component: () => import('../views/order/order-index'),
    meta: { title: '订单' }
  },
  {
    path: '/applyIndex',
    component: () => import('../views/apply/apply-index'),
    meta: { title: '车管家' }
  }, {
    path: '/applyAdd',
    component: () => import('../views/apply/apply-add'),
    meta: { title: '车管家' }
  }, {
    path: '/applyInput',
    component: () => import('../views/apply/apply-input'),
    meta: { title: '车管家' }
  }, {
    path: '/applyDtl',
    component: () => import('../views/apply/apply-dtl'),
    meta: { title: '审批详情' }
  }, {
    path: '/bind',
    component: () => import('../views/bind/bind-index'),
    meta: { title: '手机绑定' }
  }, {
    path: '/staff',
    component: () => import('../views/gzh/staff/staff-index'),
    meta: { title: '费用审批' }
  }, {
    path: '/staffMsg',
    component: () => import('../views/gzh/staff/reject-msg'),
    meta: { title: '驳回理由填写' }
  }, {
    path: '/privacy',
    component: () => import('../views/login/PrivacyPolicy'),
    meta: { title: '用户隐私协议' }
  }, {
    path: '/hislist',
    component: () => import('../views/history/his-index'),
    meta: { title: '配送记录' }
  }, {
    path: '/driverApplyDtl',
    component: () => import('../views/gzh/driver/apply-dtl'),
    meta: { title: '审批详情' }
  }, {
    path: '/bindSuccess',
    component: () => import('../views/bind/bind-success'),
    meta: { title: '手机绑定成功' }
  },
  {
    path: '/bindAlready',
    component: () => import('../views/bind/bind-already'),
    meta: { title: '手机已绑定' }
  }, {
    path: '/orderAdd',
    component: () => import('../views/work/order/order-add'),
    meta: { title: '新增订单' }
  }, {
    path: '/work',
    component: () => import('../views/index/work-index'),
    meta: { title: '车管家调度端' }
  }, {
    path: '/address',
    component: () => import('../views/address/address-select'),
    meta: { title: '地址选择' }
  }, {
    path: '/addressAdd',
    component: () => import('../views/address/address-add'),
    meta: { title: '地址详情' }
  }, {
    path: '/vehicle',
    component: () => import('../views/work/vehicle-select'),
    meta: { title: '车辆选择' }
  }, {
    path: '/belongEdit',
    component: () => import('../views/work/order/belong-edit'),
    meta: { title: '外单客户' }
  }, {
    path: '/addressIndex',
    component: () => import('../views/address/address-index'),
    meta: { title: '地址管理' }
  }, {
    path: '/workOrderlist',
    component: () => import('../views/work/orderlist/orderlist-index'),
    meta: { title: '订单总览' }
  }, {
    path: '/orderEdit',
    component: () => import('../views/work/order/order-edit'),
    meta: { title: '订单编辑' }
  }, {
    path: '/driver',
    component: () => import('../views/driver/driver-index'),
    meta: { title: '司机管理' }
  }, {
    path: '/driverAdd',
    component: () => import('../views/driver/driver-add'),
    meta: { title: '新增司机信息' }
  }, {
    path: '/driverEdit',
    component: () => import('../views/driver/driver-edit'),
    meta: { title: '编辑司机信息' }
  }, {
    path: '/truck',
    component: () => import('../views/truck/truck-index'),
    meta: { title: '车辆管理' }
  }, {
    path: '/truckAdd',
    component: () => import('../views/truck/truck-add'),
    meta: { title: '新增车辆' }
  }, {
    path: '/truckEdit',
    component: () => import('../views/truck/truck-edit'),
    meta: { title: '编辑车辆信息' }
  }, {
    path: '/driverInputPhone',
    component: () => import('../views/driver/driver-input-phone'),
    meta: { title: '司机手机信息' }
  }, {
    path: '/driverInputName',
    component: () => import('../views/driver/driver-input-name'),
    meta: { title: '司机手机姓名' }
  }, {
    path: '/driverInputLicense',
    component: () => import('../views/driver/driver-input-license'),
    meta: { title: '司机车牌信息' }
  }, {
    path: '/vehicleCheckbox',
    component: () => import('../views/work/vehicle-checkbox-select'),
    meta: { title: '车辆多选' }
  },  {
    path: '/workApply',
    component: () => import('../views/workApply/work-apply-index.vue'),
    meta: { title: '调度审批管理' }
  }, {
    path: '/workWaitApply',
    component: () => import('../views/workApply/work-wait-apply.vue'),
    meta: { title: '待审批管理' }
  }, {
    path: '/workHistoryApply',
    component: () => import('../views/workApply/work-wait-apply.vue'),
    meta: { title: '审批记录' }
  }, {
    path: '/workApplyDtl',
    component: () => import('../views/workApply/work-apply-detail.vue'),
    meta: { title: '审批单详情' }
  }, {
    path: '/truckDriverSelect',
    component: () => import('../views/truck/truck-driver-select'),
    meta: { title: '司机选择' }
  }, {
    path: '/workApplyIndex',
    component: () => import('../views/work/apply/work-apply-index'),
    meta: { title: '报销管理' }
  }, {
    path: '/workApplyAdd',
    component: () => import('../views/work/apply/work-apply-add'),
    meta: { title: '新增报销' }
  }, {
    path: '/workApplyNode',
    component: () => import('../views/work/apply/work-apply-dtl'),
    meta: { title: '审核节点' }
  }, {
    path: '/repair',
    component: () => import('../views/repair/index.vue'),
    meta: { title: '维修列表' }
  }, {
    path: '/repairAdd',
    component: () => import('../views/repair/add.vue'),
    meta: { title: '新增维修' }
  }, {
    path: '/orderlistv2',
    component: () => import('../views/work/orderlistv2/index.vue'),
    meta: { title: '全部订单' }
  }, {
    path: '/orderCheck',
    component: () => import('../views/work/orderCheck/index.vue'),
    meta: { title: '订单审核' }
  }, {
    path: '/orderDetail',
    component: () => import('../views/work/orderDtl/index.vue'),
    meta: { title: '订单详情' }
  }
  , {
    path: '/addressv2',
    component: () => import('../views/work/addressv2/index.vue'),
    meta: { title: '地址管理v2' }
  }, {
    path: '/addressv2Detail',
    component: () => import('../views/work/addressv2/detail.vue'),
    meta: { title: '地址详情v2' }
  }, {
    path: '/gasAdd',
    component: () => import('../views/gas/gas-add.vue'),
    meta: { title: '加油/加气申请' }
  }, {
    path: '/userIndexv2',
    component: () => import('../views/index/user-index-new.vue'),
    meta: { title: '司机主页' }
  },
  {
    path: '/linePrice',
    component: () => import('../views/work/price/index.vue'),
    meta: { title: '运价管理' }
  },
  {
    path: '/orderError',
    component: () => import('../views/order/order-error.vue'),
    meta: { title: '司机异常订单' }
  },
  {
    path: '/delivery',
    component: () => import('../views/delivery/delivery-index.vue'),
    meta: { title: '配送任务' }
  },
  {
    path: '/addressv3',
    component: () => import('../views/work/addressv3/index.vue'),
    meta: { title: '地址管理v3' }
  }, {
    path: '/addressv3Detail',
    component: () => import('../views/work/addressv3/detail.vue'),
    meta: { title: '地址详情v3' }
  }, {
    path: '/dispatchRecord',
    component: () => import('../views/dispatch/dispatch-record.vue'),
    meta: { title: '派单记录' }
  }, {
    path: '/dailyData',
    component: () => import('../views/work/dailyData/index.vue'),
    meta: { title: '日运输数据' }
  }, {
    path: '/fusion',
    component: () => import('../views/fusion/index.vue'),
    meta: { title: '车管家订单匹配' }
  }, {
    path: '/managerIndex',
    component: () => import('../views/index/manager-index.vue'),
    meta: { title: '管理者主页' }
  }, {
    path: '/trajectoryDetail',
    component: () => import('../views/trajectory/detail.vue'),
    meta: { title: '运输轨迹' }
  }
]

const router = createRouter({
  mode: 'history',
  history: createWebHistory(), //生产
  //history: createWebHashHistory(), //测试
  routes
})

export default router
